module.exports = {
  "_args": [
    [
      "@emotion/core@10.0.28",
      "/home/runner/work/find-my-blocks/find-my-blocks"
    ]
  ],
  "_from": "@emotion/core@10.0.28",
  "_id": "@emotion/core@10.0.28",
  "_inBundle": false,
  "_integrity": "sha512-pH8UueKYO5jgg0Iq+AmCLxBsvuGtvlmiDCOuv8fGNYn3cowFpLN98L8zO56U0H1PjDIyAlXymgL3Wu7u7v6hbA==",
  "_location": "/@emotion/core",
  "_phantomChildren": {},
  "_requested": {
    "type": "version",
    "registry": true,
    "raw": "@emotion/core@10.0.28",
    "name": "@emotion/core",
    "escapedName": "@emotion%2fcore",
    "scope": "@emotion",
    "rawSpec": "10.0.28",
    "saveSpec": null,
    "fetchSpec": "10.0.28"
  },
  "_requiredBy": [
    "/@theme-ui/color-modes",
    "/@theme-ui/components",
    "/@theme-ui/core",
    "/@theme-ui/mdx",
    "/@theme-ui/theme-provider",
    "/@types/theme-ui__components",
    "/@wordpress/components",
    "/docz",
    "/gatsby-theme-docz"
  ],
  "_resolved": "https://registry.npmjs.org/@emotion/core/-/core-10.0.28.tgz",
  "_spec": "10.0.28",
  "_where": "/home/runner/work/find-my-blocks/find-my-blocks",
  "author": {
    "name": "mitchellhamilton",
    "email": "mitchell@mitchellhamilton.me"
  },
  "browser": {
    "./dist/core.cjs.js": "./dist/core.browser.cjs.js",
    "./dist/core.esm.js": "./dist/core.browser.esm.js"
  },
  "dependencies": {
    "@babel/runtime": "^7.5.5",
    "@emotion/cache": "^10.0.27",
    "@emotion/css": "^10.0.27",
    "@emotion/serialize": "^0.11.15",
    "@emotion/sheet": "0.9.4",
    "@emotion/utils": "0.11.3"
  },
  "description": "> Simple styling in React.",
  "devDependencies": {
    "@emotion/styled": "^10.0.27",
    "@types/react": "^16.8.20",
    "dtslint": "^0.3.0",
    "emotion": "^10.0.27",
    "emotion-server": "^10.0.27",
    "emotion-theming": "^10.0.27",
    "html-tag-names": "^1.1.2",
    "react": "^16.5.2",
    "svg-tag-names": "^1.1.1"
  },
  "files": [
    "src",
    "dist",
    "types"
  ],
  "license": "MIT",
  "main": "dist/core.cjs.js",
  "module": "dist/core.esm.js",
  "name": "@emotion/core",
  "peerDependencies": {
    "react": ">=16.3.0"
  },
  "preconstruct": {
    "umdName": "emotionCore"
  },
  "publishConfig": {
    "access": "public"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/emotion-js/emotion/tree/master/packages/core"
  },
  "scripts": {
    "test:typescript": "dtslint types"
  },
  "types": "types/index.d.ts",
  "umd:main": "dist/core.umd.min.js",
  "version": "10.0.28"
}
;